import { render, staticRenderFns } from "./historyTable.vue?vue&type=template&id=2c1f7521"
import script from "./historyTable.vue?vue&type=script&lang=js"
export * from "./historyTable.vue?vue&type=script&lang=js"
import style0 from "../index.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports